import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getCurrentLocale } from 'selectors';
import { getI18nInstance } from 'utils';

export function useTranslations() {
  const locale = useSelector((state: RootState) => getCurrentLocale(state));
  const i18n = getI18nInstance(locale);
  const [, forceUpdate] = useState({});

  useEffect(() => {
    const unsubscribe = i18n.onUpdate(() => {
      forceUpdate({});
    });

    if (i18n.isLoaded()) {
      forceUpdate({});
    }

    return unsubscribe;
  }, [i18n]);

  return i18n;
}
